import React, { useRef, useEffect } from "react";
import { logoImg } from "../../constants/Images";
import Blinking from "../../Loaders/Blinking";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { resetPassword } from "../../redux/actions/authAction";
import { Link } from "react-router-dom";
export default function ChangePassword(props) {
  const { forgetPasswordRes, isResetPasswordStarted, isAuthenticated } = useSelector((state) => state.authData);
  const dispatch = useDispatch();
  let form = useRef();
  const handleSubmit = (e) => {
    e.preventDefault();
    const { otp, password, confirm_password } = form.current;
    if(password.value !== confirm_password.value) {
      toast.error("New password and Confirm password are not same.")
      return
    } else {
      let formdata = { 
        id: forgetPasswordRes.id,
        email_verify_token: forgetPasswordRes.email_verify_token,
        password: password.value,
        otp: otp.value
      };
      dispatch(resetPassword(formdata));
    }
    
  };

  useEffect(() => {
    if (isAuthenticated) {
      props.history.push("/customers");
    }
  }, [isAuthenticated]);
  return (
    <div className="container-fluid userservice_section">
      <div className="row align-items-center">
        <div className="col-sm-12 login_part">
          <div className="clearfix registeraArea loginArea">
            {/*             <div className="text-center mb-5">
              <a
                href="https://www.lambdatest.com/"
                target="_blank"
                className="logo"
              >
                <img src={logoImg} alt="LambdaTest" />
              </a>
            </div> */}
            <h1 className="form_title">RESET PASSWORD</h1>
            <form action="" className="form"  ref={form} onSubmit={handleSubmit}>
             <div className="form-group">
                <label className="user_form_label">Verification code</label>
                <input
                  type="text"
                  className="form-control"
                  required
                  name="otp"
                />
              </div>
              <div className="form-group">
                <label className="user_form_label">Enter new password</label>
                <input
                  type="password"
                  className="form-control"
                  required
                  minLength="6"
                  name="password"
                />
              </div>
              <div className="form-group">
                <label className="user_form_label">Repeat password</label>
                <input
                  type="password"
                  className="form-control"
                  required
                  minLength="6"
                  name="confirm_password"
                />
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-dark submit-btn">
                  Reset password {isResetPasswordStarted && (
                    <Blinking />
                  )}
                </button>
              </div>
              <div className="form-group">
                <p className="termsAndService bold">
                  <span className="clearfix">
                    <span className="float-left">
                      <label className="i_agree">
                        <input type="checkbox" />
                        <samp className="customcheckbox"></samp>
                        <span>Remember Me</span>
                      </label>
                    </span>
                    <span className="float-right">
                      <Link
                        to="/login"
                      >
                        Login
                      </Link>
                    </span>
                  </span>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
